import React from 'react';
import { CheckIcon, SmileIcon, WrenchIcon, PawPrintIcon, TreesIcon } from 'lucide-react';
import { SectionEyebrow } from './SectionEyebrow';
import { Reveal } from './Reveal';
import { DIAGNOSTIC_URL } from '../lib/site';
const VERTICALS = [{
  icon: SmileIcon,
  name: 'Dental Clinics'
}, {
  icon: WrenchIcon,
  name: 'Auto Repair Shops'
}, {
  icon: PawPrintIcon,
  name: 'Veterinary Clinics'
}, {
  icon: TreesIcon,
  name: 'Landscaping'
}];
const YOUR_SIDE = ['Name one system owner and the staff who handle leads', 'A person replies to assigned leads during business hours', 'Use the pipeline as your official record', 'Review the weekly scorecard'];
export function WebPlans() {
  return <section className="mx-auto w-full max-w-7xl px-5 py-24 lg:px-8" data-id="element-215" data-mp="pl6rb3btcrcl">
      <SectionEyebrow label="Who It’s For" data-id="element-216" data-mp="1vulmdfp31f1" />
      <div className="mt-8 grid grid-cols-1 gap-12 lg:grid-cols-2" data-id="element-217" data-mp="1uszndx54uij">
        <div data-id="element-218" data-mp="3t2f9xped7v8d">
          <Reveal anim="slideInLeft" data-id="element-219" data-mp="3t2xagy828vm3">
            <h2 className="font-heading text-4xl uppercase leading-[1.02] text-white sm:text-5xl" data-id="element-220" data-mp="3t1vpa0xbysqn">Built for service businesses in Miami-Dade and Broward</h2>
            <p className="mt-5 text-[#B2B2B2]" data-id="element-221" data-mp="1rqnssfnp4wle">For businesses that already get calls and messages and want to stop losing them.</p>
          </Reveal>
          <div className="mt-10 grid grid-cols-2 gap-4" data-id="element-222" data-mp="1wk8sqd8uo0n8">
            {VERTICALS.map((v, i) => <Reveal key={v.name} anim="fadeInUp" delay={i * 0.08} data-id="element-223" data-mp="21jbmv2nakmgf" data-mpi={i}>
                <div className="flex items-center gap-3 rounded-2xl border border-white/15 bg-[#1b1b1b] p-5" data-id="element-224" data-mp="13us3fogj0zv8">
                  <v.icon className="h-6 w-6 shrink-0 text-[#FFB700]" data-id="element-225" data-mp="18t3chwyzz6ce" />
                  <span className="font-heading text-sm uppercase text-white" data-id="element-226" data-mp="1drel64dk3at1">{v.name}</span>
                </div>
              </Reveal>)}
          </div>
        </div>
        <Reveal anim="slideInUp" data-id="element-227" data-mp="2p738wxymwduw">
          <div className="h-full rounded-2xl border border-white/15 bg-[#1b1b1b] p-8" data-id="element-228" data-mp="2p61m5w89a2xc">
            <p className="text-xs font-bold uppercase tracking-widest text-[#FFB700]" data-id="element-229" data-mp="2t7dh8h9wfgcx">How we work together</p>
            <h3 className="mt-3 font-heading text-2xl uppercase text-white" data-id="element-230" data-mp="u2bzodfkbk8v">A system works when both sides do their part</h3>
            <ul className="mt-6 space-y-4" data-id="element-231" data-mp="p4ae9lunz8u8">
              {YOUR_SIDE.map(t => <li key={t} className="flex items-start gap-3 text-[15px] text-[#B2B2B2]" data-id="element-232" data-mp="133a3aum39pqx"><CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-[#FFB700]" strokeWidth={3} data-id="element-233" data-mp="y4qjp0uywq1q" />{t}</li>)}
            </ul>
            <a href={DIAGNOSTIC_URL} className="mt-8 inline-block rounded-full bg-[#FFB700] px-8 py-3.5 text-sm font-bold uppercase tracking-wider text-black" data-id="element-234" data-mp="agpea0t35pqj">Book Free Diagnostic</a>
          </div>
        </Reveal>
      </div>
    </section>;
}